/** Uses Horizon's actual quantity input; never intercepts checkout or creates a second cart request. */
class VicienciaQuantityBundles extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.formComponent = this.closest('product-form-component');
    this.addEventListener('change', (event) => {
      const radio = event.target.closest('.vqb__radio');
      if (!radio || radio.disabled) return;
      const selector = this.formComponent?.querySelector('quantity-selector-component');
      if (!selector?.setValue) return;
      selector.setValue(radio.value);
      selector.updateButtonStates?.();
      selector.dispatchEvent(new CustomEvent('quantity-selector:update', { bubbles: true, detail: { quantity: Number(radio.value) } }));
      this.sync();
    }, { signal });
    this.formComponent?.addEventListener('quantity-selector:update', () => this.sync(), { signal });
    customElements.whenDefined('quantity-selector-component').then(() => {
      if (!this.isConnected || signal.aborted) return;
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.formComponent, { subtree: true, childList: true, attributes: true, attributeFilter: ['min','max','step','data-cart-quantity','data-variant-id','data-stock','data-available'] });
      this.sync();
    });
  }
  disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  sync() {
    const selector = this.formComponent?.querySelector('quantity-selector-component');
    const input = selector?.querySelector('input[name="quantity"]');
    if (!input || !selector.setValue) { this.hidden = true; this.removeAttribute('data-ready'); return; }
    const cart = Number(input.dataset.cartQuantity || 0);
    const min = Number(input.min || 1);
    const step = Number(input.step || 1);
    const max = input.max === '' ? Infinity : Number(input.max);
    const stock = this.dataset.stock === '' ? Infinity : Number(this.dataset.stock);
    const radios = [...this.querySelectorAll('.vqb__radio')];
    for (const radio of radios) {
      const qty = Number(radio.value);
      radio.disabled = this.dataset.available !== 'true' || qty < min || (qty - min) % step !== 0 || qty + cart > Math.min(max, stock);
      radio.checked = qty === Number(input.value) && !radio.disabled;
    }
    // For quantities outside the configured offers, retain the accessible native input.
    // This also lets the customer recover when none of the configured packs is available.
    const matched = radios.some(r => r.checked);
    this.hidden = false;
    this.toggleAttribute('data-ready', matched);
  }
}
if (!customElements.get('viciencia-quantity-bundles')) customElements.define('viciencia-quantity-bundles', VicienciaQuantityBundles);
